import React, { Component } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { CameraAlt } from '@mui/icons-material';
import Delete from '@mui/icons-material/Delete';
import { Done } from '@mui/icons-material';
import useStyles from '../../../../../../css/styles_PE';

export default class CameraLib extends Component {

    constructor(props) {
        super(props);
        this.deviceWidth = "0px";
        this.deviceHeight = "0px";
        if (window.innerWidth <= 768) {
            this.deviceWidth = "270px";
            this.deviceHeight = "350px";
        }
        else {
            this.deviceWidth = "700px";
            this.deviceHeight = "900px";
        }
        this.state = {
            disableUpload: "none",
            disableDelete: "none",
        };
    }

    processDevices(devices) {
        devices.forEach(device => {
            console.log(device.label);
            this.setDevice(device);
        });
    }

    async setDevice(device) {
        const { deviceId } = device;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'environment' } });
        this.videoPlayer.srcObject = stream;
        this.videoPlayer.play();
    }

    async componentDidMount() {
        const cameras = await navigator.mediaDevices.enumerateDevices();
        this.processDevices(cameras);
    }


    takePhoto = () => {
        const { sendFile } = this.props;
        const context = this.canvas.getContext('2d');
        context.drawImage(this.videoPlayer, 0, 0, this.videoPlayer.width, (window.innerWidth <= 768) ? this.videoPlayer.height : 900); //FB 6347
        this.canvas.toBlob(sendFile);
        this.setState({ disableUpload: "flex" });
        this.setState({ disableDelete: "flex" });
        //this.props.callBack(this.canvas.toDataURL('image/png').split(';base64,')[1]);
    };

    UploadPhoto = () => {
        this.props.callBack(this.canvas.toDataURL('image/png').split(';base64,')[1]);
        console.log(this.canvas.toDataURL('image/png'));
        this.DeletePhoto();
        this.setState({ disableUpload: "none" });
        this.setState({ disableDelete: "none" });
    }

    DeletePhoto = () => {
        const context = this.canvas.getContext('2d');
        context.clearRect(0, 0, this.videoPlayer.width, this.videoPlayer.height);
        this.setState({ disableUpload: "none" });
        this.setState({ disableDelete: "none" });
    }


    render() {
        return (
            <div className="c-camera-feed"
                style={{
                    paddingTop: (window.innerWidth <= 768) ? "0px" : "100px",
                    paddingBottom: (window.innerWidth <= 768) ? "0px" : "200px",
                }}>
                <br />
                <Grid lg={12}
                    md={12}
                    sm={12} xs={12} style={{
                        maxHeight: "45vh",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex"
                    }}>
                    <video playsInline ref={ref => (this.videoPlayer = ref)} width={this.deviceWidth} height={this.deviceHeight}></video>
                </Grid>
                <br />
                <Grid container spacing={6} style={{ justifyContent: "center", paddingTop: (window.innerWidth <= 768) ? "0px" : "30%" }}>
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            startIcon={<CameraAlt />}
                            component="label"
                            onClick={this.takePhoto}
                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                        >
                        </Button>
                    </Grid>
                    <br />
                    <br />
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            component="label"
                            startIcon={<Done />}

                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                display: this.state.disableUpload,
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                            onClick={this.UploadPhoto}

                        >
                        </Button>
                    </Grid>
                    <br />
                    <br />
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            component="label"
                            startIcon={<Delete />}
                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                display: this.state.disableDelete,
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                            onClick={this.DeletePhoto}
                        >
                        </Button>
                    </Grid>
                </Grid>
                <br />
                <Grid lg={12}
                    md={12}
                    sm={12} xs={12} style={{
                        maxHeight: "45vh",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        paddingTop: (window.innerWidth <= 768) ? "0px" : "30%"  // FB 6347
                    }}>
                    <canvas width={this.deviceWidth} height={this.deviceHeight} ref={ref => (this.canvas = ref)} ></canvas>
                </Grid>
            </div>
        );
    }
}